import * as React from 'react';
import Project from 'src/entities/Project';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import SuccessfulInvestmentComponent,
{ SuccessfulInvestmentComponentProps }
  from 'src/modules/modals/investment-funnel/SuccessfulInvestment.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { 
  getProjectInvested, 
  GetProjectInvestedAction 
} from 'src/actions/project/investment/get/GetProjectInvested.actions';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';

interface StateProps {
  project?: Project;
  personId: number | null;
}

interface DispatchProps {
  getProjectInvested: (projectId: number, physicalPersonId: number) => Promise<GetProjectInvestedAction>;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
}

class SuccessfulInvestmentContainer extends React.Component<Props> {

  public componentDidMount() {
    this.props.getProjectInvested(this.props.project!.id, this.props.personId!);
  }

  public render(): React.ReactNode {
    if (!this.props.project) {
      return <LoadingContainer/>;
    }

    return <SuccessfulInvestmentComponent {...this.getComponentProps()} />;
  }

  private getComponentProps(): SuccessfulInvestmentComponentProps {
    if (!this.props.project) {
      throw new Error('some props are not defined');
    }

    return {
      project: this.props.project,
      modalRef: this.props.modalRef,
    };
  }
}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
    project: state.getProject.project || undefined,
    personId: state.getUser.activeProfile ? state.getUser.activeProfile.id : null,
  });

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => ({
  getProjectInvested: (projectId: number, physicalPersonId: number): Promise<GetProjectInvestedAction> => {
    return dispatch(getProjectInvested(projectId, physicalPersonId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessfulInvestmentContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/SuccessfulInvestment.container.tsx